import React from 'react';

import {
  SliderRelated,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';
import {
  Node,
} from '@uncinc/react-drupal-core';

import {
  ButtonWrapper,
} from '../../../components';

import useValueForCurrentViewPort from '../../../helpers/useValueForCurrentViewPort';
import {
  PAGES_MORE_NEWS_URL,
} from '../../../config/constants';


import './style.scss';

const SliderNextArrow = ({ onClick, currentSlide, slideCount }) => {
  return (
    <div className={`SliderRelated__next ${currentSlide === (slideCount - 1) ? 'disabled' : ''}`} onClick={onClick}>
      <div className="icon-before icon-arrow" />
    </div>
  );
};

const SliderPrevArrow = ({ onClick, currentSlide, slideCount }) => {
  return (
    <div className={`SliderRelated__prev ${currentSlide === 0 ? 'disabled' : ''}`} onClick={onClick}>
      <div className="icon-before icon-arrow" />
    </div>
  );
};

const ViewRecentArticles = ({ entities, label = 'text_paragraph.read_more' }) => {
  const slidesToShow = useValueForCurrentViewPort(1, 2, 2, 3, 3);
  const { t } = useTranslation();

  const readMoreLabel = t(label);

  if (entities.size > 0) {
    return (
      <div className="View ViewRecentArticles">
        <div className="ViewRecentArticles__text">
          <h2>{readMoreLabel}</h2>
          <div className="ViewRecentArticles__button--desktop">
            <ButtonWrapper type="tertiary" href={PAGES_MORE_NEWS_URL}>{t('all_articles')}</ButtonWrapper>
          </div>
        </div>
        <SliderRelated
          autoplay={false}
          slidesToShow={slidesToShow}
          infinite={false}
          prevArrow={<SliderPrevArrow />}
          nextArrow={<SliderNextArrow />}
          centerMode={false}
        >
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'ViewRecentArticles__item';
            return (
              <div key={`${uuid}:${langcode}`} className="">
                <div className={className}>
                  <Node
                    id={id}
                    key={`${uuid}:${langcode}`}
                    entity={entity}
                    viewMode="teaser"
                  />
                </div>
              </div>
            );
          })}
        </SliderRelated>
        <div className="ViewRecentArticles__button--mobile">
          <ButtonWrapper type="tertiary" href={PAGES_MORE_NEWS_URL}>{t('all_articles')}</ButtonWrapper>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default ViewRecentArticles;
